import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=46c5c29e&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c5c29e')) {
      api.createRecord('46c5c29e', component.options)
    } else {
      api.reload('46c5c29e', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=46c5c29e&", function () {
      api.rerender('46c5c29e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uNU0VI6AmA82/JS/comp/IncreaseNumber.vue"
export default component.exports